module.exports = __webpack_public_path__ + "static/point-to-point-39324b7c9bf41d24baf29b9d020f40f3.jpg";